import { commentModels } from "./comment";
import { libraryModels } from "./library";
import { mediaModels } from "./media";
import { publicShowroomModels } from "./publicShowroom";
import { showroomModels } from "./showroom";
import { smallTeamModels } from "./smallTeam";
import { sparkModels } from "./spark";
import { userModels } from "./user";
import { workshopModels } from "./workshop";

export const MODELS = {
  ...userModels,
  ...workshopModels,
  ...sparkModels,
  ...publicShowroomModels,
  ...smallTeamModels,
  ...showroomModels,
  ...commentModels,
  ...libraryModels,
  ...mediaModels,
};
